import appApi from '../../../../api/app-api';
import globalPaymentServices from '../../../../stores/global-payment-services';
import { toast } from 'react-toastify';
import {
  ApiErrorCodes,
  displayErrorText,
} from '../../../../api/errors/api-error-codes';

export const deletePaymentServiceOperation = async (
  paymentServiceId: number,
  setDeletePaymentServiceId: (id: number | null) => void,
) => {
  try {
    setDeletePaymentServiceId(paymentServiceId);

    const res = await appApi.deletePaymentService(paymentServiceId);
    if (res.data.ok) {
      await globalPaymentServices.fetchPaymentService();
      if (
        res.data.errCode &&
        res.data.errCode === ApiErrorCodes.PAYMENT_SERVICE_HAS_ALLOCATIONS
      ) {
        toast.warn(displayErrorText(res.data.errCode));
      }
    }
    setDeletePaymentServiceId(null);
  } catch (e) {
    setDeletePaymentServiceId(null);
    console.error(
      `deletePaymentServiceOperation failed with paymentServiceId: ${paymentServiceId}, and error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
